import { render, staticRenderFns } from "./QuestionAnswer.vue?vue&type=template&id=4955a04a&"
import script from "./QuestionAnswer.vue?vue&type=script&lang=js&"
export * from "./QuestionAnswer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports